"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AgentIcon;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("./shared/icon-base"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function AgentIcon(props) {
  return (0, _core.jsx)(_iconBase.default, _extends({
    viewBox: "0 0 24 24"
  }, props), (0, _core.jsx)("circle", {
    cx: "12",
    cy: "10",
    r: "3.5",
    fill: "none",
    stroke: "currentColor"
  }), (0, _core.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "9",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }), (0, _core.jsx)("path", {
    d: "M5 16.8a8 8 0 0 1 6.5-3.3h1a8 8 0 0 1 6.6 3.4",
    fill: "none",
    stroke: "currentColor"
  }), (0, _core.jsx)("rect", {
    x: "10.5",
    y: "13.5",
    width: "3",
    height: "3",
    rx: "1",
    ry: "1",
    fill: "none",
    stroke: "currentColor"
  }), (0, _core.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: ".93",
    d: "M14 21l-1.1-4.5h-1.8L10 21"
  }));
}